<template>
  <div class="wrapper">
    <div class="cards">
      <el-card class="el_card" shadow="always">
        <div class="labels">
          <div class="icon">
            <div class="round"></div>
          </div>
          <div class="texts">
            <div class="t1">昨日订单数（单）</div>
            <div class="t2">{{orderCountData.orderNum || 0}}</div>
          </div>
        </div>
        <div class="detail">
          <div class="t1">比前天</div>
          <div class="t2 down" v-if="((orderCountData.orderNum || 0) - (orderCountData2.orderNum || 0)) < 0">{{(orderCountData.orderNum || 0) - (orderCountData2.orderNum || 0)}}单</div>
          <div class="t2 up" v-if="((orderCountData.orderNum || 0) - (orderCountData2.orderNum || 0)) > 0">{{(orderCountData.orderNum || 0) - (orderCountData2.orderNum || 0)}}单</div>
          <div class="t2" v-if="((orderCountData.orderNum || 0) - (orderCountData2.orderNum || 0)) === 0">{{(orderCountData.orderNum || 0) - (orderCountData2.orderNum || 0)}}单</div>
        </div>
      </el-card>
      <el-card class="el_card" shadow="always">
        <div class="labels">
          <div class="icon icon_r">
            <div class="round"></div>
          </div>
          <div class="texts">
            <div class="t1">昨日总额（元）</div>
            <div class="t2">{{orderCountData.orderMoney || 0}}</div>
          </div>
        </div>
        <div class="detail">
          <div class="t1">比前天</div>
          <!-- <div class="t2 up">{{orderCountData2.orderMoney || 0}}元</div> -->
          <div class="t2 down" v-if="((orderCountData.orderMoney || 0) - (orderCountData2.orderMoney || 0)) < 0">{{(orderCountData.orderMoney || 0) - (orderCountData2.orderMoney || 0)}}元</div>
          <div class="t2 up" v-if="((orderCountData.orderMoney || 0) - (orderCountData2.orderMoney || 0)) > 0">{{(orderCountData.orderMoney || 0) - (orderCountData2.orderMoney || 0)}}元</div>
          <div class="t2" v-if="((orderCountData.orderMoney || 0) - (orderCountData2.orderMoney || 0)) === 0">{{(orderCountData.orderMoney || 0) - (orderCountData2.orderMoney || 0)}}元</div>
        </div>
      </el-card>
      <el-card class="el_card" shadow="always">
        <div class="labels">
          <div class="icon icon_b">
            <div class="round"></div>
          </div>
          <div class="texts">
            <div class="t1">慢病普通会员/截至昨天</div>
            <div class="t2">{{vipCountData.chronicMemberNum || 0}}</div>
          </div>
        </div>
        <div class="detail">
          <div class="t1">比前天</div>
          <div class="t2 down" v-if="((vipCountData.chronicMemberNum || 0) - (vipCountData2.chronicMemberNum || 0)) < 0">{{(vipCountData.chronicMemberNum || 0) - (vipCountData2.chronicMemberNum || 0)}}人</div>
          <div class="t2 up" v-if="((vipCountData.chronicMemberNum || 0) - (vipCountData2.chronicMemberNum || 0)) > 0">{{(vipCountData.chronicMemberNum || 0) - (vipCountData2.chronicMemberNum || 0)}}人</div>
          <div class="t2" v-if="((vipCountData.chronicMemberNum || 0) - (vipCountData2.chronicMemberNum || 0)) === 0">{{(vipCountData.chronicMemberNum || 0) - (vipCountData2.chronicMemberNum || 0)}}人</div>
        </div>
      </el-card>
      <el-card class="el_card" shadow="always">
        <div class="labels">
          <div class="icon icon_y">
            <div class="round"></div>
          </div>
          <div class="texts">
            <div class="t1">vip会员/截至昨天</div>
            <div class="t2">{{vipCountData.vipMemberNum || 0}}</div>
          </div>
        </div>
        <div class="detail">
          <div class="t1">比前天</div>
          <div class="t2 down" v-if="((vipCountData.vipMemberNum || 0) - (vipCountData2.vipMemberNum || 0)) < 0">{{(vipCountData.vipMemberNum || 0) - (vipCountData2.vipMemberNum || 0)}}人</div>
          <div class="t2 up" v-if="((vipCountData.vipMemberNum || 0) - (vipCountData2.chronicMemberNum || 0)) > 0">{{(vipCountData.vipMemberNum || 0) - (vipCountData2.vipMemberNum || 0)}}人</div>
          <div class="t2" v-if="((vipCountData.vipMemberNum || 0) - (vipCountData2.vipMemberNum || 0)) === 0">{{(vipCountData.vipMemberNum || 0) - (vipCountData2.vipMemberNum || 0)}}人</div>
        </div>
      </el-card>
    </div>
    <div class="cards">
      <el-card class="el_card" shadow="always">
        <div class="titles">
          <div class="t">稀缺药代购</div>
          <el-button type="primary" v-if="drugCountData.pendingOrderNum > 0" @click="onIndentOrder">待处理：{{drugCountData.pendingOrderNum || 0}}单</el-button>
        </div>
        <div class="data_item">
          <div class="item">
            <div class="t1">{{drugCountData.orderTotalmoney || 0}}</div>
            <div class="t2">总销售额</div>
          </div>
          <div class="item">
            <div class="t1">{{drugCountData.orderYesterdaymoney || 0}}</div>
            <div class="t2">昨日销售额</div>
          </div>
          <div class="item">
            <div class="t1">{{drugCountData.pendingOrderNum || 0}}</div>
            <div class="t2">待处理（单）</div>
          </div>
        </div>
      </el-card>
      <el-card class="el_card" shadow="always">
        <div class="titles">
          <div class="t">VIP男女占比</div>
        </div>
        <div class="bar_wrap">
          <div class="i_b"></div>
          <div class="bar">
            <div class="b_bar" :style="{width: userCountData.manSexRatio || '0%'}">{{userCountData.manSexRatio || '0%'}}</div>
            <div class="g_bar">{{userCountData.womanSexRatio || '0%'}}</div>
          </div>
          <div class="i_g"></div>
        </div>
      </el-card>
    </div>
    <div class="label_title">增长趋势分析</div>
    <div class="cards">
      <el-card class="el_card" shadow="always">
        <!-- <schart ref="bar" class="schart" canvasId="bar" :options="options"></schart> -->
        <div id="barChart" :style="{width: '100%', height: '300px'}"></div>
      </el-card>
      <el-card class="el_card" shadow="always">
        <div id="pieChart" :style="{width: '500px', height: '300px'}"></div>
      </el-card>
    </div>
  </div>
</template>

<script>
let self = null;
import { getDate, fun_date } from '@/utils/index';
// import Schart from 'vue-schart';
// import echarts from 'echarts';
export default {
  name: 'index',
  // components: { Schart },
  data() {
    return {
      loginData: JSON.parse(localStorage.getItem('loginData')),
      orderCountData: {}, // 昨天的数据
      orderCountData2: {}, // 前天的数据
      vipCountData: {}, // 昨天的数据
      vipCountData2: {}, // 今天的数据
      drugCountData: {}, // 药品数据
      userCountData: {}, // 用户数据
      sixMonthOrderData: {}, // 近6个月订单数据
      totalData: {},
      sixFlag: false,
      totalFlag: false
      // options: this.getLineCfg()
    }
  },
  mounted() {
    self = this;
    console.log(this.$echarts);
    this.getOrderCount();
    this.getOrderCount2();
    this.getVipCount();
    this.getVipCount2();
    this.getDrugCount();
    this.getUserCount();
    this.getSixMonthOrderData();
    this.getAllMemberOrderAndMember();
    // this.initPie();
  },
  methods: {
    getSixMonthOrderData() {
      let params = { enterpriseId: self.loginData.enterpriseId }
      this.$https.get('system/memberOrderDataStatistics/pastSixMonthsGrowthTrend', params).then(res => {
        if (res.code === 200) {
          self.sixMonthOrderData = res.data || {};
          self.sixFlag = true;
          self.initBar();
        }
        console.log(res);
        // _this.enterpriseList = res.data || [];
      }).catch(res => {
        // this.$message.error(res.msg || '接口请求异常');
      });
    },
    getAllMemberOrderAndMember() {
      let params = { enterpriseId: self.loginData.enterpriseId }
      this.$https.get('system/memberOrderDataStatistics/getAllMemberOrderAndMember', params).then(res => {
        if (res.code === 200) {
          self.totalData = res.data || {};
          self.totalFlag = true;
          self.initBar();
        }
        console.log(res);
        // _this.enterpriseList = res.data || [];
      }).catch(res => {
        // this.$message.error(res.msg || '接口请求异常');
      });
    },
    getUserCount() {
      let params = { enterpriseId: self.loginData.enterpriseId }
      this.$https.get('system/memberDataStatistics/memberVipTypeStatisticsRatio', params).then(res => {
        if (res.code === 200) {
          self.userCountData = res.data || {};
          self.initPie();
        }
        console.log(res);
        // _this.enterpriseList = res.data || [];
      }).catch(res => {
        // this.$message.error(res.msg || '接口请求异常');
      });
    },
    getDrugCount() {
      let params = { enterpriseId: self.loginData.enterpriseId }
      this.$https.get('system/memberOrderDataStatistics/purchasingAgentOrder', params).then(res => {
        if (res.code === 200) {
          self.drugCountData = res.data || {};
        }
        console.log(res);
        // _this.enterpriseList = res.data || [];
      }).catch(res => {
        // this.$message.error(res.msg || '接口请求异常');
      });
    },
    getOrderCount() {
      let params = { enterpriseId: self.loginData.enterpriseId, statisticsDate: getDate('-', fun_date(-1), false) }
      this.$https.get('system/memberOrderDataStatistics/getMemberOrderAndMemberByDate', params).then(res => {
        if (res.code === 200) {
          self.orderCountData = res.data || {};
        }
        console.log(res);
        // _this.enterpriseList = res.data || [];
      }).catch(res => {
        // this.$message.error(res.msg || '接口请求异常');
      });
    },
    getOrderCount2() {
      let params = { enterpriseId: self.loginData.enterpriseId, statisticsDate: getDate('-', fun_date(-2), false) }
      this.$https.get('system/memberOrderDataStatistics/getMemberOrderAndMemberByDate', params).then(res => {
        if (res.code === 200) {
          self.orderCountData2 = res.data || {};
        }
        console.log(res);
        // _this.enterpriseList = res.data || [];
      }).catch(res => {
        // this.$message.error(res.msg || '接口请求异常');
      });
    },
    getVipCount() {
      let params = { enterpriseId: self.loginData.enterpriseId, statisticsDate: getDate('-', fun_date(-1), false) }
      this.$https.get('system/memberDataStatistics/memberTypeDataStatistics', params).then(res => {
        if (res.code === 200) {
          self.vipCountData = res.data || {};
        }
        console.log(res);
        // _this.enterpriseList = res.data || [];
      }).catch(res => {
        // this.$message.error(res.msg || '接口请求异常');
      });
    },
    getVipCount2() {
      let params = { enterpriseId: self.loginData.enterpriseId, statisticsDate: getDate('-', fun_date(-2), false) }
      this.$https.get('system/memberDataStatistics/memberTypeDataStatistics', params).then(res => {
        if (res.code === 200) {
          self.vipCountData2 = res.data || {};
        }
        console.log(res);
        // _this.enterpriseList = res.data || [];
      }).catch(res => {
        // this.$message.error(res.msg || '接口请求异常');
      });
    },
    onIndentOrder() {
      this.$router.push({ path: '/indent_order' });
    },
    initBar() {
      if (self.totalFlag && self.sixFlag) {
        let barChart = this.$echarts.init(document.getElementById('barChart'));
        barChart.setOption(this.getBarCfg());
      }
    },
    initPie() {
      let pieChart = this.$echarts.init(document.getElementById('pieChart'));
      pieChart.setOption(this.getPieCfg());
    },
    getBarCfg() {
      let xData = [];
      let sData = [];
      self.sixMonthOrderData.map(d => {
        xData.push(d.statisticsMonth); // 月份
        sData.push(d.orderMoney); // 金额 orderNum vipMemberNum
      })
      return {
        title: {
          text: `订单总额：${self.totalData.orderMoney || 0}（元）｜VIP会员：${self.totalData.vipMemberNum || 0}人`,
          textStyle: { //设置主标题风格
            color: '#1890FF', //设置主标题字体颜色
            fontSize: 15,
            fontWeight: 'normal',
          },
          subtext: `以下近六月的增长趋势`
        },
        tooltip: {
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          formatter: (params) => {
            let style = `display: inline-block; width: 8px; height: 8px; background: ${params.color};border-radius: 50%;margin-right: 5px;`;
            let style2 = `display: inline-block; width: 8px; height: 8px; background: #f2637b;border-radius: 50%;margin-right: 5px;`;
            let html = `
              <div><span style='${style}'></span>订单金额：${self.sixMonthOrderData[params.dataIndex].orderMoney || 0}元</div>
              <div><span style='${style2}'></span>VIP会员：${self.sixMonthOrderData[params.dataIndex].vipMemberNum}人</div>
            `
            console.log(params);
            return html;
          },
          textStyle: {
            color: '#fff'
          }
        },
        xAxis: {
          // data: ["10月", "11月", "12月", "01月", "02月", "03月"]
          data: xData
        },
        yAxis: {
          splitLine: {
            lineStyle: {
              type: 'dashed' // 横线轴虚线
            }
          }
        },
        series: [{
          name: '',
          type: 'bar',
          barWidth: 30, //柱图宽度
          itemStyle: { // 柱子的颜色
            color: '#409eff',
          },
          data: sData
        }]
      }
    },
    getPieCfg() {
      return {
        title: {
          text: `VIP年龄占比`,
          textStyle: { //设置主标题风格
            color: '#1890FF', //设置主标题字体颜色
            fontSize: 15,
            fontWeight: 'normal',
          },
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: '80%',
          top: 'middle',
          align: 'left',
          itemGap: 20,
          itemWidth: 8,
          itemHeight: 8,
        },
        graphic: [{
          type: "text",
          left: "center",
          top: "40%",
          style: {
            text: `总人数（人）`,
            textAlign: "center",
            fill: "#a7a7a7",
            fontSize: 13,
            fontWeight: 500
          }
        },
        {
          type: "text",
          left: "center",
          top: "50%",
          style: {
            text: `${self.userCountData.vipMemberTotalCount || '0'}`,
            textAlign: "center",
            fill: "#333",
            fontSize: 45,
            fontWeight: 700
          }
        },
        ],
        series: [{
          // left: '-30%',
          name: '总人数（人）',
          type: 'pie',
          // radius: '50%',
          radius: ['60%', '78%'], // 空心
          avoidLabelOverlap: false,
          label: { // 隐藏掉指引线
            show: false,
            position: 'center'
          },
          data: [
            {
              value: self.userCountData.firstAgeSectionCount || 0,
              name: `1-30岁 | ${self.userCountData.firstAgeSectionRatio || '0%'}`
            },
            {
              value: self.userCountData.secondAgeSectionCount || 0,
              name: `30-40岁 | ${self.userCountData.secondAgeSectionRatio || '0%'}`
            },
            {
              value: self.userCountData.thirdAgeSectionCount || 0,
              name: `40-50岁 | ${self.userCountData.thirdAgeSectionRatio || '0%'}`
            },
            {
              value: self.userCountData.fourAgeSectionCount || 0,
              name: `50-60岁 | ${self.userCountData.fourAgeSectionRatio || '0%'}`
            },
            {
              value: self.userCountData.fiveAgeSectionCount || 0,
              name: `60以上 | ${self.userCountData.fiveAgeSectionRatio || '0%'}`
            }
          ],
          itemStyle: {
            normal: {
              borderWidth: 4,
              borderColor: '#fff'
            }
          },
          emphasis: {
            itemStyle: {
              // shadowBlur: 1,
              // shadowOffsetX: 0,
              // shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      }
    }
  }
}
</script>

<style lang="less" scoped>
//  .content-box {
// }
.wrapper {
    // background: rgba(249, 251, 251, 1);
    // width: 1192px;
}
.cards {
    display: flex;
    align-items: cebnter;
    margin-bottom: 20px;
    .el_card {
        flex: 1;
        margin-right: 20px;
        border: none;
        box-shadow: 0 2px 12px rgba(245, 238, 238, 0.5);
        .labels {
            display: flex;
            align-items: center;
            padding-bottom: 20px;
            margin-bottom: 20px;
            border-bottom: 1px solid #e3e3e3;
            .icon {
                margin-right: 8px;
                width: 70px;
                height: 70px;
                // background: #effaf3;
                background: url(~@/assets/img/zrdd.png) no-repeat center / 100% 100%;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                .round {
                    display: none;
                    width: 30px;
                    height: 30px;
                    background: #23ab98;
                    border-radius: 50%;
                }
            }
            .icon_r {
                // background: #fff1ed;
                background: url(~@/assets/img/zrze.png) no-repeat center / 100% 100%;
                .round {
                    background: #fd7a69;
                }
            }
            .icon_b {
                // background: #ecfbff;
                background: url(~@/assets/img/mbpt.png) no-repeat center / 100% 100%;
                .round {
                    background: #15caff;
                }
            }
            .icon_y {
                // background: #ffefd4;
                background: url(~@/assets/img/vip_member.png) no-repeat center / 100% 100%;
                .round {
                    background: #ffae26;
                }
            }
            .texts {
                flex: 1;
                .t1 {
                    margin-bottom: 5px;
                    font-size: 14px;
                    color: #a7a7a7;
                }
                .t2 {
                    font-size: 30px;
                }
            }
        }
        .detail {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .t1 {
                // font-size: 12px;
                color: #a7a7a7;
            }
            .t2 {
                display: flex;
                align-items: center;
                // font-size: 12px;
                color: #333;
            }
            .up:before {
                content: '';
                display: block;
                margin-right: 10px;
                border-left: 5px solid transparent;
                border-right: 5px solid transparent;
                border-bottom: 10px solid rgba(82, 196, 26, 0.647058823529412);
            }
            .down:before {
                content: '';
                display: block;
                margin-right: 10px;
                border-left: 5px solid transparent;
                border-right: 5px solid transparent;
                border-top: 10px solid #f5222d;
            }
        }
        .titles {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 30px;
            .t {
                font-size: 18px;
                color: #1890ff;
            }
        }
        .data_item {
            display: flex;
            align-items: center;
            .item {
                flex: 1;
                .t1 {
                    font-size: 30px;
                    color: #333;
                }
                .t2 {
                    color: #a7a7a7;
                }
            }
        }
        .bar_wrap {
            display: flex;
            align-items: center;
            .i_b {
                width: 40px;
                height: 40px;
                background: url('~@/assets/img/b.png');
            }
            .i_g {
                width: 40px;
                height: 40px;
                background: url('~@/assets/img/g.png');
            }
            .bar {
                flex: 1;
                display: flex;
                align-items: center;
                margin: 0 20px;
                height: 30px;
                color: #fff;
                .b_bar {
                    width: 50%;
                    height: 30px;
                    line-height: 30px;
                    text-align: center;
                    background: rgba(24, 144, 255, 0.847058823529412);
                }
                .g_bar {
                    flex: 1;
                    // width: 50%;
                    height: 30px;
                    line-height: 30px;
                    text-align: center;
                    background: rgba(247, 125, 183, 1);
                }
            }
        }
    }
    .el_card:last-child {
        margin-right: 0;
    }
}
.label_title {
    padding: 0 0 0 10px;
    margin-bottom: 20px;
    border-left: 5px solid #1890ff;
    font-size: 18px;
    color: #1890ff;
}
.schart {
    width: 100%;
    height: 300px;
}
</style>
